import { VideoRoom, VideoRoom_State } from "protogen/video_pb";
import Duration from "../common/Duration";
import SvgIcon from "@mui/material/SvgIcon";
import FeedEntryBox from "../common/FeedEntryBox";
import { getFormattedDuration } from "../../common/utils";
import LinkRouter from "../navigation/LinkRouter";
import { Video } from "lucide-react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { AccountStub } from "../../protogen/common_pb";
import { ReactElement } from "react";

const subtitleForVideoCall = (videoRoom: VideoRoom): string => {
  switch (videoRoom.state) {
    case VideoRoom_State.COMPLETED:
      return "Video call completed";
    case VideoRoom_State.ACTIVE:
      return "Active video call";
    case VideoRoom_State.CREATING:
      return "Starting video call";
    case VideoRoom_State.FAILED:
    default:
      return "Video call failed";
  }
};

type VideoCallPreviewProps = {
  videoRoom: VideoRoom;
  participants: AccountStub[];
};

export default ({ videoRoom, participants }: VideoCallPreviewProps) => {
  const subtitle = subtitleForVideoCall(videoRoom);
  const duration = getFormattedDuration(
    Number(videoRoom.lastUpdatedSec),
    Number(videoRoom.creationSec),
  );

  const suggestions = () => {
    return (
      <LinkRouter to={`/video/${encodeURIComponent(videoRoom.uuid)}`}>
        <Typography
          variant={"bodySmall"}
          sx={{ cursor: "pointer", color: "#198282" }}
        >
          {videoRoom.state === VideoRoom_State.COMPLETED
            ? "See details"
            : "Join call"}
        </Typography>
      </LinkRouter>
    );
  };

  const creationDate = new Date(Number(videoRoom.creationSec) * 1000);
  const maybeLink = (content: ReactElement) => {
    return videoRoom.state !== VideoRoom_State.COMPLETED ? (
      <LinkRouter to={`/video/${encodeURIComponent(videoRoom.uuid)}`}>
        {content}
      </LinkRouter>
    ) : (
      content
    );
  };

  return (
    // Don't hijack the click event if the call is completed
    maybeLink(
      <FeedEntryBox
        header={
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            <Typography variant="bodySmallHeavy">
              {participants.length > 0
                ? participants.map((p) => p?.firstName).join(", ")
                : "Video call"}
            </Typography>
            <Typography variant="bodySmall">
              {videoRoom.state === VideoRoom_State.ACTIVE ? (
                <Duration startTime={creationDate} />
              ) : (
                duration
              )}
            </Typography>
          </Box>
        }
        subheader={
          videoRoom.state === VideoRoom_State.COMPLETED ? (
            suggestions()
          ) : (
            <Typography variant="bodySmall" color="textSecondary">
              {subtitle}
            </Typography>
          )
        }
        icon={
          <SvgIcon sx={{ fontSize: 20, color: "#6B6E7B" }}>
            <Video />
          </SvgIcon>
        }
      />,
    )
  );
};
